import React, { useState } from "react";
import "../styles/ForgotDetailsModal.css";
import { fetchSubscriptionForgotPasswordUserApi, fetchContactdetail } from '../api/api';
import { useNavigate } from "react-router-dom";

const ForgotDetailsModal = ({ open, onClose, withoutloginredirect='' }) => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("password");
  const [formData, setFormData] = useState({
    paypalEmail: "",
    contactEmail: "",
    fullName: "",
    possibleEmails: "",
    extraInfo: "",
    passwordEmail: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Handle Password reset
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.passwordEmail) {
      setError("Email field is required.");
      return;
    }

    if (!validateEmail(formData.passwordEmail)) {
      setError("Please enter a valid email.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetchSubscriptionForgotPasswordUserApi(formData.passwordEmail);

      if (response.statuscode === 200) {
        setSuccess(response.message || "Forgot password link sent to your email.");
        setFormData({ ...formData, passwordEmail: "" });
        setTimeout(() => {
            if (withoutloginredirect) {
                onClose();
                navigate(`/${withoutloginredirect}`);
            } else {
                onClose();
                navigate("/");
            }
            }, 3000);
      } else if (response.statuscode === 404) {
        setError(response.message);
      } else {
        setError("Invalid email.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again later.");
    }
    setLoading(false);
  };

  // Handle Contact Support form
  const handleSupportSubmit = async(e) => {
    e.preventDefault();
    if (
      !validateEmail(formData.paypalEmail) ||
      !validateEmail(formData.contactEmail) ||
      !formData.fullName
    ) {
      setError("Please fill all required fields correctly.");
      return;
    }
    try {
      const response = await fetchContactdetail(formData.paypalEmail,formData.contactEmail,formData.fullName,formData.possibleEmails,formData.extraInfo);

      if (response.statuscode === 200) {
        setSuccess(response.message || "Thanks for contacting support.");
        setFormData({ 
          paypalEmail: "",
          contactEmail: "",
          fullName: "",
          possibleEmails: "",
          extraInfo: "",
          passwordEmail: ""
        });
        setTimeout(() => {
            onClose();
        }, 3000);
      } else if (response.statuscode === 404) {
        setError(response.message);
      } else {
        setError("Invalid email.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again later.");
    }
    setSubmitted(true);
    setTimeout(() => {
    if (withoutloginredirect) {
        
        onClose();
        navigate(`/${withoutloginredirect}`);
    } else {
        onClose();
        navigate("/");
    }
    }, 3000);
  };

  if (!open) return null;

  return (
    <div className="modal-overlay-forgot">
      <div
        className="modal-content-forgot"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="modal-close-forgot" onClick={onClose}>
          &times;
        </span>

        <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px" }}>
          Forgot Details
        </div>

        {/* Tabs */}
        <div className="tabs-forgot">
          <button
            className={activeTab === "password" ? "tab-forgot active" : "tab"}
            onClick={() => {
              setActiveTab("password");
              setSubmitted(false);
              setError("");
              setSuccess("");
            }}
          >
            Password
          </button>
          <button
            className={activeTab === "email" ? "tab-forgot active" : "tab"}
            onClick={() => {
              setActiveTab("email");
              setSubmitted(false);
              setError("");
              setSuccess("");
            }}
          >
            Email
          </button>
        </div>

        {/* Password Tab */}
        {activeTab === "password" && (
          <div className="tab-panel-forgot">
            <p>Enter your email and we'll send you instructions to reset your password.</p>
            {error && <p className="email-error-msg" style={{textAlign:'center'}}>{error}</p>}
            {success && <p className="thank-you-message" style={{textAlign:'center'}}>{success}</p>}

            <form onSubmit={handlePasswordReset}>
              <label style={{ textAlign: "left" }}>Email:</label>
              <input
                type="email"
                name="passwordEmail"
                placeholder="Enter Your Email"
                value={formData.passwordEmail}
                onChange={handleChange}
                required
              />
              <button type="submit" className="btn-forgot" disabled={loading}>
                {loading ? "Sending..." : "Reset Password"}
              </button>
            </form>
          </div>
        )}

        {/* Email Tab */}
        {activeTab === "email" && !submitted && (
          <div className="tab-panel-forgot">
            <form onSubmit={handleSupportSubmit}>
              <label>PayPal Email *</label>
              <input
                type="email"
                name="paypalEmail"
                value={formData.paypalEmail}
                onChange={handleChange}
                required
              />

              <label>Contact Email *</label>
              <input
                type="email"
                name="contactEmail"
                value={formData.contactEmail}
                onChange={handleChange}
                required
              />

              <label>Full Name *</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />

              <label>Possible Account Emails</label>
              <input
                type="text"
                name="possibleEmails"
                value={formData.possibleEmails}
                placeholder="Enter possible emails separated by commas"
                onChange={handleChange}
              />

              <label>Anything else we should know?</label>
              <input
                type="text"
                name="extraInfo"
                value={formData.extraInfo}
                onChange={handleChange}
              />

              <p style={{marginBottom:'0px'}}>Please tell us as much as you can and our support team will get back to you</p>

              <button type="submit" className="btn-forgot">
                Contact Support
              </button>
            </form>
          </div>
        )}

        {/* Success Message for Email Tab */}
        {activeTab === "email" && submitted && (
          <div className="success-message-forgot">
            Thanks — we’ve created a support request.
            <br />
            We’ve emailed <strong>{formData.contactEmail}</strong> and will get
            back to you shortly.
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotDetailsModal;
